import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../hooks/useSubscription';
import { Warning } from '@phosphor-icons/react';

export default function TrialBanner() {
  const { isTrial, daysLeft, isActive } = useSubscription();
  const navigate = useNavigate();

  if (!isTrial || !isActive || daysLeft === null) {
    return null;
  }

  const isUrgent = daysLeft <= 7;

  return (
    <div className={`${isUrgent ? 'bg-red-600' : 'bg-primary'} text-white py-3 px-4`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          {isUrgent && <Warning size={20} weight="fill" />}
          <span className="text-sm font-bold">
            {daysLeft === 0
              ? 'Your free trial ends today!'
              : `${daysLeft} day${daysLeft === 1 ? '' : 's'} left in your free trial`}
          </span>
        </div>
        <button
          onClick={() => navigate('/settings/subscription')}
          className="bg-white text-primary px-4 py-1 rounded-lg text-sm font-semibold hover:bg-gray-100 transition"
        >
          Subscribe now
        </button>
      </div>
    </div>
  );
}
